import React, { useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { CssBaseline, Box, useMediaQuery, Select, MenuItem, FormControl } from '@mui/material'; // Select, MenuItem, FormControl 추가
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Outlet } from 'react-router-dom';

import LeftDrawer from './LeftDrawer';
import DrawerHeader from './DrawerHeader';
import NotiContainer from '../../../containers/common/header/NotiContainer';
import UserMenuContainer from '../../../containers/common/header/UserMenuContainer';
import LinkBoxContainer from '../../../containers/common/header/LinkBoxContainer';
import ProjectCounterContainer from '../../../containers/common/projectCounter/ProjectCounterContainer';
import CompanySelect from './CompanySelect';
const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      marginTop: theme.spacing(-1.5),
      padding: theme.spacing(1.5)
    },
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer - 1, 
  [theme.breakpoints.up('md')]: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
    },
}));

const DrawerTemplate = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = React.useState(!isMobile);
  
  // 셀렉트 박스 상태 관리 (기본값: 'hcinfo')
  const [siteType, setSiteType] = React.useState(() => {
    return localStorage.getItem('current_company') || 'hcinfo';
  });

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // 셀렉트 변경 핸들러
  const handleSiteChange = (event) => {
    setSiteType(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex',  }}>
      <CssBaseline />

      <AppBar position="fixed" open={open} color="default" >
        <Toolbar variant="dense" 
          sx={{
            '@media (max-width: 899px)': {
              minHeight: '45px !important',
              height: '45px',
              px: 1,
            },
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            sx={{ mr: 2, ...(open && { display: 'none' }) }}
          >
            <MenuOpenIcon />
          </IconButton>
          
          <Box sx={{ mx: 1, display: { xs: 'none', md: 'block' } }}>
            <NotiContainer />
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <ProjectCounterContainer />
          </Box>
          
          <Box sx={{ flexGrow: 1 }} />
          
          <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, py: 1 }}>
            <Box sx={{ mr: 1 }}><UserMenuContainer /></Box>
            
            {/* 데스크탑에서만 보이는 영역 */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
              <LinkBoxContainer />
              <CompanySelect siteType={siteType} onSiteChange={handleSiteChange} />
            </Box>

          </Box>
        </Toolbar>
      </AppBar>

      <LeftDrawer
        theme={theme}
        drawerWidth={drawerWidth}
        open={open}
        handleDrawerClose={handleDrawerClose}
        isMobile={isMobile} 
      />

      <Main open={open} onClick={isMobile ? handleDrawerClose : undefined}>
        <DrawerHeader />
        <Box> 
          <Outlet />
        </Box>
      </Main>
    </Box>
  );
};

export default DrawerTemplate;
